import { computed, ref, watch, type ComputedRef } from 'vue';

export const ASK_PREVIEW_LIMIT = 5;

export const useAskPreviewList = <T>(items: ComputedRef<T[]>, limit = ASK_PREVIEW_LIMIT) => {
  const isExpanded = ref(false);

  watch(items, () => {
    isExpanded.value = false;
  });

  const visibleItems = computed(() => (isExpanded.value ? items.value : items.value.slice(0, limit)));
  const hasHiddenItems = computed(() => items.value.length > limit);
  const togglePreview = () => {
    isExpanded.value = !isExpanded.value;
  };

  return {
    limit,
    isExpanded,
    visibleItems,
    hasHiddenItems,
    togglePreview,
  };
};
